<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Solutions from '$lib/PageSections/Solutions/Solutions.svelte';

	import InsulatingDoublePaneWindowsWithIndowInsertsImage from './images/insulating_double_pane_windows_with_indow_inserts.jpg';
	import ThermalImagesWith23DegreeDifferenceBetweenIndowInsertAndNoInsertImage from './images/thermal_images_with23_degree_difference_between_indow_insert_and_no_insert.jpg';
</script>

<Section>
	<p>
		Scott Knapp and his wife built their house on Lake Ontario themselves. They
		bought new wood insulating double-pane windows from a huge, reputable window
		company to make their home warm and snug. It was a company, Scott says, that
		“sells them by the boatload.” But to the couple’s surprise, the double-pane
		windows were drafty right from the start.
	</p>
	<p>
		Chaumont, New York can get cold, sometimes minus 30° Fahrenheit. Scott asked
		the company for new seals but none of the fixes were able to improve window
		insulation or stop the drafts.
	</p>
	<Image
		alt="exterior and interior of a house using Indow inserts for insulating double-pane windows"
		src={InsulatingDoublePaneWindowsWithIndowInsertsImage}
		class="w-full"
	/>
</Section>

<Section>
	<h2>Insulating Double-Pane Windows with Inserts</h2>
	<p>
		As a home performance contractor, Scott had done a super job of insulating
		the house but needed needed help when it came to insulating double-pane
		windows. He wasn’t about to replace them since they were brand new, so he
		bought insulating blinds as a stop gap measure. He and his wife were so cold
		that first winter, they couldn’t even watch television in the main living
		room.
	</p>
	<p>
		He then found Indow window inserts, which immediately solved the problem.
		His wife, who is sensitive to drafts, told him, “There’s a huge difference
		in here.”
	</p>
	<Image
		alt="thermal gun images showing one window at 31.5 degrees, one window with Indow insert insulating double pane window at 54.5 degrees"
		src={ThermalImagesWith23DegreeDifferenceBetweenIndowInsertAndNoInsertImage}
		class="w-full"
	/>
</Section>

<Section>
	<h2>Insulated Double-Pane Window 23° Warmer</h2>
	<p>
		Scott used his thermal imaging gun to see the difference he and his wife
		could both feel. <strong>
			It showed the window with an Indow insert was 23° warmer than the one
			without
		</strong>. The inserts took care of the condensation problem on the windows
		and the boiler doesn’t have to run as much to heat the home. To learn how
		these increased window surface temperatures create greater comfort, check
		out our
		<a href="/static/pdfs/IW-Comfort-w-ROI-09-16-14.pdf"
			>‘Comfort Finally Has an ROI’ document</a
		>.
	</p>
	<p class="text-indow-blue! italic">
		“The changes in the home were…amazing,” said Scott.
	</p>
</Section>

<Awards />
<GetAFreeEstimate title="Let Us Help You" />

<Solutions />
